<template>

  <div class="etx-container Container" :class="paragraphClassList">

    <div class="etx-center Center">

      <BlokkliProxyMode :isEditing="isEditing" fieldName="field_teasers_text_image_rev" :elements="teasers" vertical />
      <div class="etx-flex Flex tab-s:c-2 gv-300">

        <div v-for="teaser in teasers" class="etx-flex__item Flex__item">

          <div class="etx-card Card has-link" :class="entranceClassList">

            <a class="etx-card__link Card__link" :href="teaser?.link?.domainUri?.path || teaser?.link?.uri?.path" :title="teaser?.alt" :target="teaser?.targetBlank"></a>

            <div class="etx-card__item Card__item ph-0 pv-0">

              <div class="etx-media Media">
                <MediaImage :media="teaser?.image" imageStyle="image_2_1" />
              </div>

            </div>

            <div class="etx-card__item Card__item pt-200 pb-0 grow-1">

              <div class="etx-text Text">
                <p class="font-h3">{{ teaser?.heading }}</p>
                <p class="font-lead" v-if="teaser?.lead" v-html="teaser?.lead.replace(/\n/g, '<br>')"></p>
                <HelperHtmlRenderer :htmlContent="teaser?.text" />
              </div>

            </div>

            <div class="etx-card__item Card__item pt-150 pb-150 has-link">

              <div class="etx-button-list ButtonList">

                <a class="etx-button Button" :href="teaser?.link?.domainUri?.path || teaser?.link?.uri?.path" :title="teaser?.alt" :target="teaser?.targetBlank ? '_blank' : undefined">
                  <div class="etx-button__text Button__text">
                    <span>{{ teaser?.label }}</span>
                  </div>
                  <div class="etx-button__icon Button__icon">
                    <i class="far fa-long-arrow-right"></i>
                  </div>
                </a>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  teasers: Array<any>
}>()


const { options, isEditing } = defineBlokkli({
  bundle: 'teaser_2_col_text_image',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})


</script>
